import { render, staticRenderFns } from "./YoutubeEmbed.vue?vue&type=template&id=1977aa2e&scoped=true&"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeEmbed.vue?vue&type=style&index=0&id=1977aa2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977aa2e",
  null
  
)

export default component.exports